import React from "react";
import { useTranslation } from "react-i18next";
import moment from "moment";
import "moment-precise-range-plugin";
import { OcInfoCardItem } from "oc/components";

interface OcInfoCardPeriodProps {
  validFrom: string | null;
  validTo: string | null;
  translation?: string;
}

export const OcInfoCardPeriod: React.FC<OcInfoCardPeriodProps> = ({
  validFrom,
  validTo,
  translation = "Period",
}) => {
  const { t } = useTranslation();
  if (!validFrom && !validTo) return null;
  let start = moment(validFrom);
  let end = validTo || moment();
  let period = (moment as any).preciseDiff(start, end, true);
  let startString = validFrom
    ? new Date(validFrom).toLocaleDateString()
    : t("UNKNOWN_DATE");
  let endString = validTo
    ? new Date(validTo).toLocaleDateString()
    : t("MY_HR_PRESENT");

  let periodString = "";

  period.months += 1;

  if (period?.years === 1) {
    periodString = periodString + period.years + ` ${t("OC_YEAR")}`;
  }
  if (period?.years > 1) {
    periodString = periodString + period.years + ` ${t("OC_YEARS")}`;
  }
  if (period.months === 1) {
    if (period?.years === 0) {
      periodString = periodString + period.months + ` ${t("OC_MONTH")}`;
    } else {
      periodString = periodString + ", " + period.months + ` ${t("OC_MONTH")}`;
    }
  }
  if (period.months > 1) {
    if (period?.years === 0) {
      periodString = periodString + period.months + ` ${t("OC_MONTHS")}`;
    } else {
      periodString = periodString + ", " + period.months + ` ${t("OC_MONTHS")}`;
    }
  }

  if (periodString !== "") {
    periodString = `(${periodString})`;
  }

  let value = `${startString} - ${endString} ${periodString}`;
  return (
    <OcInfoCardItem
      label={t("OC_VALIDITY")}
      value={value}
      translation={translation}
    />
  );
};

export default OcInfoCardPeriod;
